import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-privacy-policy',
  template: `
    <h1 class="p-2">{{ 'privacyPolicy.privacyPolicy' | translate }}</h1>

    <div class="p-3">
      <h3>{{ 'privacyPolicy.introductionTitle' | translate }}</h3>
      <p>{{ 'privacyPolicy.introduction' | translate }}</p>
      <h3>{{ 'privacyPolicy.dataControllerTitle' | translate }}</h3>
      <p>{{ 'privacyPolicy.dataController' | translate }}</p>
      <h3>{{ 'privacyPolicy.dataWeCollectTitle' | translate }}</h3>
      <p>{{ 'privacyPolicy.dataWeCollect' | translate }}</p>
      <ul>
        <li>
          <strong>{{ 'privacyPolicy.dataWeCollect1Title' | translate }}</strong>
          {{ 'privacyPolicy.dataWeCollect1Text' | translate }}
        </li>
        <li>
          <strong>{{ 'privacyPolicy.dataWeCollect2Title' | translate }}</strong>
          {{ 'privacyPolicy.dataWeCollect2Text' | translate }}
        </li>
        <li>
          <strong>{{ 'privacyPolicy.dataWeCollect3Title' | translate }}</strong>
          {{ 'privacyPolicy.dataWeCollect3Text' | translate }}
        </li>
      </ul>
      <h3>{{ 'privacyPolicy.howDoWeUseTheDataTitle' | translate }}</h3>
      <p>{{ 'privacyPolicy.howDoWeUseTheData' | translate }}</p>
      <h3>{{ 'privacyPolicy.storageAndSecurityTitle' | translate }}</h3>
      <p>{{ 'privacyPolicy.storageAndSecurity' | translate }}</p>
      <h3>{{ 'privacyPolicy.sharingDataTitle' | translate }}</h3>
      <p>{{ 'privacyPolicy.sharingData' | translate }}</p>
      <h3>{{ 'privacyPolicy.legalBasisTitle' | translate }}</h3>
      <p>{{ 'privacyPolicy.legalBasis' | translate }}</p>
      <h3>{{ 'privacyPolicy.yourRightsTitle' | translate }}</h3>
      <p>{{ 'privacyPolicy.yourRights' | translate }}</p>
      <h3>{{ 'privacyPolicy.changesTitle' | translate }}</h3>
      <p>{{ 'privacyPolicy.changes' | translate }}</p>
    </div>
  `,
  styles: [``],
  standalone: true,
  imports: [RouterOutlet, TranslateModule],
})
export class PrivacyPolicyComponent {}
